module.exports = __webpack_public_path__ + "static/media/EXTC_Video.d6fc84a5.mp4";